module.exports = __webpack_public_path__ + "static/img/成功案例3.4c8f1c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/成功案例3.png
// module id = J/WE
// module chunks = 1